// ABOUTME: Resolves WhatsApp pre-registration interface labels from translation metadata.
// ABOUTME: Lets each company name its Branch concept in WhatsApp screens.
const labelNames = [
    "title",
    "description",
    "setupGuideTitle",
    "setupGuideDescription",
    "setupIntegrationTitle",
    "setupIntegrationPending",
    "setupIntegrationComplete",
    "setupDestinationsTitle",
    "setupDestinationsPending",
    "setupDestinationsComplete",
    "setupRoutingTitle",
    "setupRoutingPending",
    "setupRoutingComplete",
    "setupOwnersTitle",
    "setupOwnersPending",
    "setupOwnersComplete",
    "setupSaveTitle",
    "setupSavePending",
    "setupSaveComplete",
    "setupRolloutTitle",
    "setupRolloutPending",
    "setupRolloutComplete",
    "helpButton",
    "helpTitle",
    "helpIntro",
    "helpIntegration",
    "helpDestinations",
    "helpRouting",
    "helpOwners",
    "helpActivation",
    "helpGeneralNumber",
    "helpLinks",
    "helpServerValidation",
    "routingMode",
    "routingModeCompany",
    "routingModeCompanyHelp",
    "routingModeBranch",
    "routingModeBranchHelp",
    "routingModeRegionBranch",
    "routingModeRegionBranchHelp",
    "branches",
    "companyResponders",
    "companyRespondersHelp",
    "companyRespondersRequired",
    "branchesRequired",
    "stores",
    "regions",
    "assignments",
    "assignmentsHelp",
    "links",
    "generalEntry",
    "generalEntryHelp",
    "runtimeEnabled",
    "runtimeEnabledHelp",
    "generalNumberEntryMode",
    "generalNumberEntryModeHelp",
    "generalNumberEntryDisabled",
    "generalNumberEntryUnmatchedOnly",
    "generalNumberEntryAllIdleContacts",
    "rolloutInactive",
    "rolloutActive",
    "rolloutEnabled",
    "rolloutEnabledHelp",
    "rolloutEnableConfirm",
    "rolloutDisableConfirm",
    "rolloutUpdateError",
    "configurationActive",
    "configurationInactive",
    "integration",
    "phoneNumber",
    "flowModel",
    "flowModelVersionAvailableHelp",
    "consentVersion",
    "consentText",
    "destinations",
    "futureJobsText",
    "futureJobsUrl",
    "nonRecruitingText",
    "nonRecruitingUrl",
    "regionId",
    "regionName",
    "regionIdentifierHelp",
    "active",
    "addRegion",
    "addAssignment",
    "user",
    "regionsForUser",
    "storesForUser",
    "unavailable",
    "save",
    "saving",
    "saved",
    "loading",
    "retry",
    "loadError",
    "saveError",
    "coverageBranchesTitle",
    "coverageBranchesHelp",
    "coverageBranchesRemaining",
    "conflict",
    "noRegions",
    "noAssignments",
    "noLinks",
    "store",
    "region",
    "status",
    "link",
    "actions",
    "exportCsv",
    "generate",
    "rotate",
    "revoke",
    "copy",
    "open",
    "viewQr",
    "qrTitle",
    "close",
    "rotateConfirm",
    "revokeConfirm",
    "linkRotated",
    "linkCreated",
    "linkRevoked",
    "linkCopied",
    "linkActionError",
    "unknownStatus",
    "linkUnavailable",
    "delete",
    "saveBeforeLinkAction",
    "dirtyLinksNotice"
] as const;

type WhatsappPreRegistrationTranslationValues = Record<string, string | number>;

export type WhatsappPreRegistrationLabels = Record<
    (typeof labelNames)[number],
    string
> & {
    formatFlowModelVersionAvailable: (values: {
        activeVersion: number;
        publishedVersion: number;
    }) => string;
};

export const getWhatsappPreRegistrationLabels = (
    translate: (
        key: string,
        values?: WhatsappPreRegistrationTranslationValues
    ) => string
): WhatsappPreRegistrationLabels => ({
    ...Object.fromEntries(
        labelNames.map((name) => [
            name,
            translate(`whatsappPreRegistration_${name}`)
        ])
    ),
    formatFlowModelVersionAvailable: (values) =>
        translate("whatsappPreRegistration_flowModelVersionAvailable", values)
});
